<script setup>
  /* global defineProps */
  import { formatGenerationDuration, formatReplayLanguage } from './replayLabels'
  defineProps({ attempts: { type: Array, default: () => [] } })
  const status = (value) =>
    ({
      QUEUED: '排队中',
      PROCESSING: '制作中',
      RETRY_WAIT: '等待重试',
      BLOCKED: '制作失败',
      COMPLETED: '已完成',
      COMPLETED_WITH_WARNINGS: '已完成，含补齐内容',
    }[value] || '待处理')
</script>
<template>
  <details v-if="attempts.length" class="attempts">
    <summary>语种制作记录（{{ attempts.length }}）</summary>
    <p v-for="(attempt, index) in attempts" :key="index">
      {{ attempt.outputId === 'original' ? '原声' : formatReplayLanguage(attempt.language) }} ·
      {{ status(attempt.status) }} · {{ new Date(attempt.createdAtMs).toLocaleString() }} · 耗时
      {{ formatGenerationDuration(attempt.generationDurationMs) }}
    </p>
  </details>
</template>
<style scoped>
  .attempts {
    font-size: 13px;
    color: #606266;
  }
  summary {
    cursor: pointer;
  }
</style>
